import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont, pxToCssFontSize } from '@vfit/shared/themes';

export const SearchContainer = styled.div`
  position: relative;
  border-radius: 15px;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  color: ${colors.$ffffff};
  width: fit-content;
  p,
  h2 {
    margin-top: 0;
  }
  // background: lightgray -559.748px -0.989px / 530.809% 142.365% no-repeat;

  @media (min-width: ${breakpoints.tablet}) {
    // margin: 0 32px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    // margin: 0 80px;
    // width: 1280px;
    // background: lightgray -90.989px -7.584px / 134.803% 121.78% no-repeat;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr); // MOBILE
  justify-items: center;
  grid-gap: 24px;

  @media (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(2, 0fr); // TABLET
    justify-content: center;
    row-gap: 32px;
    column-gap: 24px;
  }
  @media (min-width: ${breakpoints.bigDesktop}) {
    grid-template-columns: repeat(4, 1fr); // DESKTOP
    row-gap: 48px;
    column-gap: 32px;
  }
`;

export const ItemContainer = styled.div`
  background-color: transparent;
  color: ${colors.$0d0d0d};
  cursor: pointer;
}
`;

export const Divider = styled.div`
  box-sizing: border-box;
  height: 32px;
  @media (min-width: ${breakpoints.tablet}) {
    height: 40px;
  }
  @media (min-width: ${breakpoints.bigDesktop}) {
    height: 50px;
  }
`;

export const DividerGrid = styled.div`
  box-sizing: border-box;
  height: 48px;
  @media (min-width: ${breakpoints.tablet}) {
    height: 48px;
  }
  @media (min-width: ${breakpoints.bigDesktop}) {
    height: 64px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 32px;
  z-index: 2;
  text-align: center;
  button {
    width: 200px;
  }
`;

export const TitleH3 = styled.h3`
  font-family: ${fonts.regular};
  font-style: normal;
  font-weight: 400;
  ${pxToCssFontSize(30)}
  color: ${colors.$ffffff};
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFontSize(30)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 48)}
  }
`;
